import { whitelabelConfigs, WhitelabelKey } from "@App/configs";
import defaultConfig from "@App/configs/default";
import { Config } from "@App/configs/interfaces";
import { Organization } from "@App/types";

/**
 * Retrieves the configuration for a given organization.
 *
 * @param {Organization} [organization] - The organization object containing the UUID.
 * @returns {Config} - The merged configuration for the organization, or the default configuration if the organization is not found.
 */
export function getConfig(organization?: Organization): Config {
  // Extract the UUID from the organization object, if provided.
  const uuid = organization?.uuid;

  // Return the default configuration if the UUID is not provided or does not exist in whitelabelConfigs.
  if (!uuid || !(uuid in whitelabelConfigs)) {
    return defaultConfig;
  }

  // Merge the default configuration with the whitelabel configuration for the given UUID.
  return { ...defaultConfig, ...whitelabelConfigs[uuid as WhitelabelKey] };
}
